import { render, staticRenderFns } from "./SuppliedItems.vue?vue&type=template&id=1eaf23b0&scoped=true"
import script from "./SuppliedItems.vue?vue&type=script&lang=js"
export * from "./SuppliedItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eaf23b0",
  null
  
)

export default component.exports